import { createContext, useContext } from 'react';

export interface FileGalleryRegistrationContextValue {
  register: (saveCallback: (recordId: string | number) => Promise<boolean>) => void;
}

export const FileGalleryRegistrationContext = createContext<FileGalleryRegistrationContextValue>({
  register: () => {}
});

export const useFileGalleryRegistration = () => useContext(FileGalleryRegistrationContext);
